import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ShellComponent } from './shell/shell.component';
import { DomSanitizer } from '@angular/platform-browser';
import { ConfirmDialogModule } from '../common/components/confirm-dialog/confirm-dialog.module';
import { LoginModule } from './login/login.module';
import { AuthGuard } from '../common/guards/auth.guard';
import { AutoLoginGuard } from '../common/guards/autologin.guard';
import { LoadGuard } from '../common/guards/load.guard';
import { LocationModule } from '../location/location.module';
import { AuthPresentGuard } from '../common/guards/auth-present.guard';
import { ShellModule } from './shell/shell.module';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { LoginComponent } from './login/login.component';

const routes: Routes = [
    {
        path: '',
        canActivate: [AuthPresentGuard],
        component: LoginComponent,
    },
    {
        path:'autologin',
        canActivate: [AutoLoginGuard],
        component: LoginComponent
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canLoad: [LoadGuard],
        component: ShellComponent,
        children: [
            {
                path: 'places',
                loadChildren: () => import('../devices/devices.module').then(m => m.DevicesModule)
            },
            {
                path: 'settings',
                loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule)
            },
            {
                path: 'notifications',
                loadChildren: () => import('./notifications/notifications.module').then(m => m.NotificationsModule)
            },
            {
                path: 'insights',
                loadChildren: () => import('./insights/user-insights/user-insights.module').then(m => m.UserInsightsModule)
            },
            {
                path: 'home',
                loadChildren: () => import('src/app/modules/portal/home/home.module').then(m => m.HomeModule)
            },
            {
                path: 'controlAudits',
                loadChildren: () => import('src/app/modules/portal/control-audits/control-audits.module').then(m => m.ControlAuditsModule)
            },
            {
                path: 'help',
                loadChildren: () => import('src/app/modules/portal/help/help.module').then(m => m.HelpModule)
            },
            {
                path: 'location',
                loadChildren: () => import('src/app/modules/portal/location-settings/location-settings.module').then(m => m.LocationSettingsModule)
            }
        ]
    },
    {
        path: '**',
        redirectTo: '/not-found'
    },
    {
        path: 'not-found',
        loadChildren: () => import('./page-not-found/page-not-found.module').then(m => m.PageNotFoundModule)
    }
];

@NgModule({

    imports: [
        CommonModule,
        ConfirmDialogModule,
        LoginModule,
        LocationModule,
        MatIconModule,
        RouterModule.forChild(routes),
        ShellModule
    ],
    exports: [
        RouterModule
    ]
})
export class PortalModule {
    constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
        PortalModule.registerIcons(iconRegistry, sanitizer);
    }

    public static registerIcons(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer): void {
        iconRegistry
            .addSvgIcon('caslink',
                sanitizer.bypassSecurityTrustResourceUrl('assets/caslink.svg'))
            .addSvgIcon('caslink-white',
                sanitizer.bypassSecurityTrustResourceUrl('assets/caslink_white.svg'));
    }
}
